import { axios } from 'lib/axios';

export const loginWithSMSOTP = () => {
  return axios.get('/user/sms/sendCode');
};
